import {
  formatDateForDisplay,
  formatDateForInput,
  formatDateTimeForInput,
  parseDateInput,
  parseDateTimeInput,
} from './period-calculator';

export function parseIsoDate(value: string): Date | undefined {
  if (!value) return undefined;
  const date = new Date(value);
  return isNaN(date.getTime()) ? undefined : date;
}

export function areIsoDatesEqual(a: any, b: any): boolean {
  const aTime = parseIsoDate(String(a))?.getTime();
  const bTime = parseIsoDate(String(b))?.getTime();
  return aTime !== undefined && aTime === bTime;
}

export function formatDateDisplayValue(value: any): string {
  if (!value) return '';

  return formatDateForDisplay(value);
}

export function parseInputDateValue(value: string, includeTime: boolean): Date | undefined {
  if (!value) return undefined;
  return includeTime ? parseDateTimeInput(value) : parseDateInput(value);
}

export function formatInputDateValue(date: Date, includeTime: boolean): string {
  return includeTime ? formatDateTimeForInput(date) : formatDateForInput(date);
}

export function formatIsoToInput(value: string, includeTime: boolean): string | null {
  const date = parseIsoDate(value);
  return date ? formatInputDateValue(date, includeTime) : null;
}

export function formatInputToIso(
  value: string | null | undefined,
  includeTime: boolean
): string | null {
  if (!value) return null;
  const date = parseInputDateValue(value, includeTime);
  return date ? date.toISOString() : null;
}
